import React from "react";
import { motion } from "framer-motion";
import "./Skills.css";

const skills = [
  { name: "Python", icon: "devicon-python-plain" },
  { name: "JavaScript", icon: "devicon-javascript-plain" },
  { name: "Java", icon: "devicon-java-plain" },
  { name: "C", icon: "devicon-c-plain" },
  { name: "TypeScript", icon: "devicon-typescript-plain" },
  { name: "Linux", icon: "devicon-linux-plain" },
  { name: "Node.js", icon: "devicon-nodejs-plain" },
  { name: "HTML", icon: "devicon-html5-plain" },
  { name: "CSS", icon: "devicon-css3-plain" },
  { name: "React", icon: "devicon-react-original" },
  { name: "Next.js", icon: "devicon-nextjs-plain" }, 
  { name: "Flutter", icon: "devicon-flutter-plain" },
  { name: "Pytorch", icon: "devicon-pytorch-plain" }, 
  { name: "Pandas", icon: "devicon-pandas-plain" }, 
  { name: "Git", icon: "devicon-git-plain" }, 
  { name: "Computer Vision", icon: "devicon-opencv-plain" },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

function Skills() {
  return (
    <motion.div
      className="skills-container"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {skills.map((skill, index) => (
        <motion.div
          className="skill-item"
          key={index}
          variants={itemVariants}
        >
          <i className={`skill-icon ${skill.icon}`}></i>
          <span>{skill.name}</span>
        </motion.div>
      ))}
    </motion.div>
  );
}

export default Skills;
